// Use only for the record that identifies a detail page, not for auxiliary requests.
export const isValidDetailId = (id) =>
  typeof id === 'string' && /^[1-9]\d*$/.test(id) && Number.isSafeInteger(Number(id));

export const isDetailNotFound = (response, detail) => {
  const httpStatus = response?.response?.status;

  if (httpStatus >= 400) return httpStatus === 404;

  const envelope = response?.response?.data ?? response;

  if (envelope?.messageCode === 404) return true;
  if (envelope?.messageCode !== 200) return false;

  // Some existing detail APIs return 200 with an empty result for a missing record.
  return detail == null || (typeof detail === 'object' && Object.keys(detail).length === 0);
};
